import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { artistInfo } from '../mock';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-teal-900/20">
      <nav className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img 
              src={artistInfo.logos.waveform} 
              alt="Brooksgordon Logo" 
              className="h-12 w-auto cursor-pointer"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/about"
              className={`transition-colors duration-200 font-medium ${isActive('/about') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'}`}
            >
              About
            </Link>
            <Link 
              to="/album"
              className={`transition-colors duration-200 font-medium ${isActive('/album') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'}`}
            >
              The Album
            </Link>
            <Link 
              to="/music"
              className={`transition-colors duration-200 font-medium ${isActive('/music') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'}`}
            >
              Music
            </Link>
            <Link 
              to="/videos"
              className={`transition-colors duration-200 font-medium ${isActive('/videos') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'}`}
            >
              Videos
            </Link>
            <Link 
              to="/gallery"
              className={`transition-colors duration-200 font-medium ${isActive('/gallery') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'}`}
            >
              Gallery
            </Link>
            <Link 
              to="/store"
              className={`transition-colors duration-200 font-medium ${isActive('/store') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'}`}
            >
              Store
            </Link>
            <Link 
              to="/booking"
              className={`transition-colors duration-200 font-medium ${isActive('/booking') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'}`}
            >
              Book Me
            </Link>
            <Link 
              to="/newsletter"
              className="bg-gold-500 hover:bg-gold-600 text-black px-6 py-2 rounded-full font-medium transition-all duration-200 hover:scale-105"
            >
              Stay Updated
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-teal-100 hover:text-gold-400 transition-colors"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-6 border-t border-teal-900/20">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/about"
                onClick={() => setIsMenuOpen(false)}
                className={`text-left py-2 font-medium ${isActive('/about') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'} transition-colors`}
              >
                About
              </Link>
              <Link 
                to="/album"
                onClick={() => setIsMenuOpen(false)}
                className={`text-left py-2 font-medium ${isActive('/album') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'} transition-colors`}
              >
                The Album
              </Link>
              <Link 
                to="/music"
                onClick={() => setIsMenuOpen(false)}
                className={`text-left py-2 font-medium ${isActive('/music') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'} transition-colors`}
              >
                Music
              </Link>
              <Link 
                to="/videos"
                onClick={() => setIsMenuOpen(false)}
                className={`text-left py-2 font-medium ${isActive('/videos') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'} transition-colors`}
              >
                Videos
              </Link>
              <Link 
                to="/gallery"
                onClick={() => setIsMenuOpen(false)}
                className={`text-left py-2 font-medium ${isActive('/gallery') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'} transition-colors`}
              >
                Gallery
              </Link>
              <Link 
                to="/store"
                onClick={() => setIsMenuOpen(false)}
                className={`text-left py-2 font-medium ${isActive('/store') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'} transition-colors`}
              >
                Store
              </Link>
              <Link 
                to="/booking"
                onClick={() => setIsMenuOpen(false)}
                className={`text-left py-2 font-medium ${isActive('/booking') ? 'text-gold-400' : 'text-teal-100 hover:text-gold-400'} transition-colors`}
              >
                Book Me
              </Link>
              <Link 
                to="/newsletter"
                onClick={() => setIsMenuOpen(false)}
                className="bg-gold-500 hover:bg-gold-600 text-black px-6 py-3 rounded-full font-medium transition-all duration-200 text-center"
              >
                Stay Updated
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
